module.exports = __webpack_public_path__ + "static/testimonial1-b8f147d30d33927391f8d45ecaca8f58.png";